import React from "react";
import Navigation from "../../components/Navigation";
import Footer from "../../components/Footer";
import './style.css';

import Balls from "../../assets/images/portfolio/Balls3.webp"

// photos
import James from "../../assets/images/portfolio/photography/img1.webp";
import Keith from "../../assets/images/portfolio/photography/img10.webp";
import Sihle from "../../assets/images/portfolio/photography/img12.webp";
import Ghost from "../../assets/images/portfolio/photography/img2.webp";
import Moses from "../../assets/images/portfolio/photography/img5.webp";
// import Bakwe from "../../assets/images/portfolio/photography/img4.webp";

const About = () => {
  return (
    <div className="about-page">
      <Navigation />
      {/* Background Image */}
      <div className="hero-bg">
        <img
          src={Balls}
          alt="Balls"
          className="hero-img"
        />
        <div className="hero-overlay" />
      </div>

      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-container">
          <h1>About Big Cat Graphics</h1>
          <p>Where imagination meets exceptional design</p>
        </div>
      </section>

      {/* About Content */}
      <section className="about-content">
        <div className="about-container">
          <h2>About</h2>
          <p>
            At Big Cat Graphics, we believe in the power of imagination and the
            impact of exceptional design. Whether you're an emerging artist
            looking to establish a unique brand identity or a corporate giant
            seeking captivating visual content, our team of talented designers,
            artists, and photographers are here to bring your vision to reality.
          </p>
          <p>
            With a portfolio boasting artworks with renowned artists such as
            Mobi Dixon, Ntsiki Mazwai, and Nasty C, and working with esteemed
            companies like DM Africa, Standard Bank, and MTV, Big Cat Graphics
            has established itself as a trusted creative partner in the
            industry.
          </p>
        </div>
      </section>

      {/* Team Section */}
      {/* James Saikonde */}
      <section className="about-team">
        <div className="about-container">
          <h2 className="center">Our Team</h2>

          <div className="team-grid">
            <div className="team-info">
              <h3>James "Mad Lion 007" Saikonde</h3>
              <h4>Founder & Creative Director</h4>
              <p>
                Meet the visionary mind behind the spellbinding visuals of
                "Music In Green" - the multi-talented creator, James "Mad Lion 007" Saikonde, founder of Big Cat Graphics. With a passion for
                pushing the boundaries of visual storytelling, Mad Lion stands
                at the forefront of VFX and CGI, seamlessly blending technical
                expertise with boundless creativity.
              </p>
              <p>
                As a VFX and CGI artist, Mad Lion has mastered the art of
                crafting immersive digital landscapes that captivate audiences
                worldwide. From breathtaking CGI creatures to awe-inspiring
                special effects, their work transcends imagination, bringing
                fantastical worlds to life with precision and detail.
              </p>

              <div className="team-stats">
                <div className="stat-card">
                  <div className="stat-number">10+</div>
                  <div className="stat-label">Years of Experience</div>
                </div>
                <div className="stat-card">
                  <div className="stat-title">Contact</div>
                  <div className="stat-label">+27 71 914 2461</div>
                </div>
              </div>
            </div>

            <div className="team-photo">
              <div className="photo-box">
                <div className="placeholder">
                  {/* <div className="icon-circle">👤</div> */}
                  <img src={James} alt="James Saikonde" className="team-image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Keith Mwelaze */}
      <section className="about-team">
        <div className="about-container">
          <div className="team-grid">
            <div className="team-photo">
              <div className="photo-box">
                <div className="placeholder">
                  {/* <div className="icon-circle">👤</div> */}
                  <img src={Keith} alt="Keith Mwelaze" className="team-image" />
                  {/* <p>Team Photo</p> */}
                </div>
              </div>
            </div>
            <div className="team-info">
              <h3>Keith Mdu "Fools Dream" Mwelaze</h3>
              <h4>Software and Web Developer</h4>
              <p>
                At the heart of the dynamic creative engine that is Big Cat Graphics, lies the indispensable expertise of its assistant and web developer. Meet Keith Mdu Mwelaze (Fools Dream) the meticulous organizer and Web Developer, both essential pillars supporting the visionary endeavors of the company.
              </p>
              <p>
                Fools Dream is the unsung hero behind the scenes, ensuring smooth operations and flawless execution of projects. With an innate knack for organization and attention to detail, Fools Dream keeps the studio running like a well-oiled machine. From coordinating schedules to managing resources, their invaluable contributions ensure that every aspect of Big Cat Graphics operates seamlessly.
              </p>

              <div className="team-stats">
                <div className="stat-card">
                  <div className="stat-number">5+</div>
                  <div className="stat-label">Years of Experience</div>
                </div>
                <div className="stat-card">
                  <div className="stat-title">Contact</div>
                  <div className="stat-label">+27 73 375 8027</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-team">
        <div className="about-container">
          <div className="team-grid">
            <div className="team-info">
              <h3>Sihle "Minnie" Mcinjana</h3>
              <h4>Musician And Model</h4>
              <p>
                I was born on September 24, 1999, in Johannesburg's vibrant Alexandra neighborhood, and I am a passionate and dynamic model with a keen eye for artistic expression. I have a deep-seated interest in travel and a commitment to exploring various forms of art and design, and I love helping others recognize and embrace their own beauty. In addition In addition to modeling, I dabble in music and painting, frequently sharing my creative content on platforms like TikTok.
              </p>
              <p>
                This diverse range of artistic pursuits fuels my passion for modeling—a field where creativity and self-expression reign supreme. I draw inspiration from the multifaceted talents of actress, model, and business owner Thuso Mbhedu, who embodies different looks and characters with such grace. Her creativity motivates me to continually evolve and push boundaries within the modeling industry. Looking Looking to the future, I aim to launch Minnie’s Lash and Glow, a beauty business that aligns with my personal values and creative endeavors. I aspire to collaborate with major brands that resonate with my artistic vision, and I am excited about the impact I can make in the modeling world
              </p>

              <div className="team-stats">
                <div className="stat-card">
                  <div className="stat-number">5+</div>
                  <div className="stat-label">Years of Experience</div>
                </div>
                <div className="stat-card">
                  <div className="stat-title">Contact</div>
                  <div className="stat-label">+27 71 123 4567</div>
                </div>
              </div>
            </div>

            <div className="team-photo">
              <div className="photo-box">
                <div className="placeholder">
                  {/* <div className="icon-circle">👤</div> */}
                  <img src={Sihle} alt="Sihle Mcinjana" className="team-image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Keith Mwelaze */}
      <section className="about-team">
        <div className="about-container">
          <div className="team-grid">
            <div className="team-photo">
              <div className="photo-box">
                <div className="placeholder">
                  {/* <div className="icon-circle">👤</div> */}
                  <img src={Moses} alt="FKA Moses" className="team-image" />
                  {/* <p>Team Photo</p> */}
                </div>
              </div>
            </div>
            <div className="team-info">
              <h3>FKA Moses</h3>
              <h4>Producer, Composer amd DK</h4>
              <p>
                FKA Moses is a dynamic creator with over 11 years of experience in music production and more than 3 years in 3D design using Blender. His journey began with a deep passion for sound, evolving into a mastery of music composition, mixing, and production that spans multiple genres. Over the years, he has honed his ability to craft immersive auditory experiences, pushing the boundaries of creativity and innovation
              </p>
              <p>
                Expanding his artistic reach, FKA Moses ventured into the world of 3D design, where he applies his keen eye for detail and storytelling to bring digital environments, animations, and visual effects to life. His work seamlessly blends sound and visuals, creating captivating projects that resonate on multiple levels. Whether designing stunning 3D visuals or composing evocative soundscapes, FKA Moses continues to explore new frontiers in digital artistry, constantly refining his craft and embracing cutting-edge technology
              </p>

              <div className="team-stats">
                <div className="stat-card">
                  <div className="stat-number">15+</div>
                  <div className="stat-label">Years of Experience</div>
                </div>
                <div className="stat-card">
                  <div className="stat-title">Contact</div>
                  <div className="stat-label">+27 71 123 4567</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-team">
        <div className="about-container">

          <div className="team-grid">
            <div className="team-info">
              <h3>Prince "Ghost the Producer" July</h3>
              <h4>The Architecture of Sound and Visionary</h4>
              <p>
                Prince July (born 19**, Soweto, Johannesburg) is a highly influential, yet notoriously reclusive, figure in the South African creative landscape. He is simultaneously a legendary music producer, known as "Ghost," and the owner and founder of the groundbreaking digital and print publication, Control Magazine.
              </p>
              <p>
                Prince July operates from the shadows. His power stems not from visibility, but from his uncanny ability to spot and shape talent—both in the recording studio and in the editorial office. He rarely gives interviews and is known to be ruthlessly protective of his creative vision and the integrity of his magazine. This reclusiveness has only amplified his legendary status, making him the ultimate gatekeeper of cool and authenticity in the South African scene.
              </p>

              <div className="team-stats">
                <div className="stat-card">
                  <div className="stat-number">10+</div>
                  <div className="stat-label">Years of Experience</div>
                </div>
                <div className="stat-card">
                  <div className="stat-title">Contact</div>
                  <div className="stat-label">+27 71 914 2461</div>
                </div>
              </div>
            </div>

            <div className="team-photo">
              <div className="photo-box">
                <div className="placeholder">
                  {/* <div className="icon-circle">👤</div> */}
                  <img src={Ghost} alt="Prince July" className="team-image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Keith Mwelaze */}
      <section className="about-team">
        <div className="about-container">
          <div className="team-grid">
            <div className="team-photo">
              <div className="photo-box">
                <div className="placeholder">
                  <div className="icon-circle">👤</div>
                  {/* <img src={Bakwe} alt="Bakwe" className="team-image" /> */}
                  <p>Bakwe Photo</p>
                </div>
              </div>
            </div>
            <div className="team-info">
              <h3>Bakwe The Buckweed</h3>
              <h4>The Cerebral MC</h4>
              <p>
                The Man.
              </p>
              <p>
                The Myth.
              </p>
              <p>
                The Legend.
              </p>

              <div className="team-stats">
                <div className="stat-card">
                  <div className="stat-number">5+</div>
                  <div className="stat-label">Years of Experience</div>
                </div>
                <div className="stat-card">
                  <div className="stat-title">Contact</div>
                  <div className="stat-label">+27 71 914 2461</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision">
        <div className="about-container">
          <div className="mv-grid">
            <div className="mv-item">
              <h3>Our Mission</h3>
              <p>
                To transform creative visions into stunning visual realities
                through innovative design, cutting-edge technology, and
                unparalleled artistic expertise. We strive to be the bridge
                between imagination and impact.
              </p>
            </div>
            <div className="mv-item">
              <h3>Our Vision</h3>
              <p>
                To be the leading creative partner for artists and brands
                worldwide, setting new standards in visual storytelling and
                establishing Big Cat Graphics as synonymous with excellence in
                design and innovation.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
